import { useParams } from 'react-router-dom';
import { Ellie } from '../../components/Ellie';
import elliePng from '../../assets/images/pliable/ellie.png';

export default function ConversationPage() {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border flex items-center gap-3">
        <img src={elliePng} alt="Ellie" className="h-10 w-10 rounded-full object-cover" />
        <div>
          <h1 className="text-2xl font-bold text-foreground">Hi, I'm Ellie</h1>
          <p className="text-sm text-muted-foreground">Your AI chief of staff — ask me about your business and get recommendations on how to change your strategy.</p>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        {id && <Ellie showHistory={true} conversationId={id} />}
      </div>
    </div>
  );
}

